import { G2, Pie } from "@ant-design/plots";
import React from "react";

type Data = {
  type: string;
  value: number;
  price: string;
};
interface Props {
  data?: Data[];
  color?: any;
}

const PieChart = ({ data = [], color = null }: Props) => {
  const G = G2.getEngine("canvas");

  const cfg = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    color: color ?? null,
    radius: 0.85,
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ value }: any) => (value === 0 ? "" : `${value}%`),
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    tooltip: {
      customContent: (title: any, items: any) => {
        return (
          <>
            <h4 style={{ marginTop: 16 }}>{title}</h4>
            <ul style={{ paddingLeft: 0 }}>
              {items?.map((item: any, index: number) => {
                const { name, value, color, data } = item;
                return (
                  <li
                    key={item.year}
                    className="g2-tooltip-list-item"
                    data-index={index}
                    style={{
                      marginBottom: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      className="g2-tooltip-marker"
                      style={{ backgroundColor: color }}
                    ></span>
                    <span
                      style={{
                        display: "inline-flex",
                        flex: 1,
                        justifyContent: "space-between",
                      }}
                    >
                      <span>
                        {data?.price} ({value}%)
                      </span>
                      {/* <span className="g2-tooltip-list-item-value">
                        {value}
                      </span> */}
                    </span>
                  </li>
                );
              })}
            </ul>
          </>
        );
      },
    },

    // legend: false,
    // label: {
    //   type: "spider",
    //   labelHeight: 40,
    //   formatter: (data: any, mappingData: any) => {
    //     const group = new G.Group({});
    //     group.addShape({
    //       type: "circle",
    //       attrs: {
    //         x: 0,
    //         y: 0,
    //         width: 40,
    //         height: 50,
    //         r: 5,
    //         fill: mappingData.color,
    //       },
    //     });
    //     group.addShape({
    //       type: "text",
    //       attrs: {
    //         x: 10,
    //         y: 8,
    //         text: `${data.type}`,
    //         fill: mappingData.color,
    //       },
    //     });
    //     group.addShape({
    //       type: "text",
    //       attrs: {
    //         x: 0,
    //         y: 25,
    //         text: `(${data.price})`,
    //         fill: "rgba(0, 0, 0, 0.65)",
    //         fontWeight: 700,
    //       },
    //     });
    //     group.addShape({
    //       type: "text",
    //       attrs: {
    //         x: 0,
    //         y: 40,
    //         text: `${data.value}%`,
    //         fill: "rgba(0, 0, 0, 0.603)",
    //         fontWeight: 500,
    //       },
    //     });
    //     return group;
    //   },
    // },
    state: {
      active: {
        style: {
          lineWidth: 0,
          fillOpacity: 0.65,
        },
      },
    },
    interactions: [
      {
        type: "element-single-selected",
      },
      {
        type: "element-active",
        // enable: false,
      },
    ],
  };
  const config: any = cfg;
  return <Pie {...config} />;
};

export default PieChart;
